<template>
  <div>
    <v-layout mb-0 mt-2 align-center justify-center row wrap>      
      <v-flex xs12 md8>
        <v-layout>
          <v-flex xs12>
            <v-text-field v-model="property.nickname" label="Nickname" box @focus="$event.target.select()"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-text-field v-model="property.address" label="Address" box @focus="$event.target.select()"></v-text-field>
          </v-flex>
          </v-layout>
          <v-layout>
          <v-flex d-flex xs12 md8>
            <v-text-field v-model="property.city" label="City" box @focus="$event.target.select()"></v-text-field>
          </v-flex>
          <v-flex d-flex xs12 md2>
            <v-text-field v-model="property.state" label="State" box @focus="$event.target.select()"></v-text-field>
          </v-flex>
          <v-flex d-flex xs12 md2>
            <v-text-field v-model="property.zip" label="Zip" box @focus="$event.target.select()"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-end row fill-height>
            Last Updated: {{ property.lastUpdated | usDate }}
        </v-layout>
        <v-layout align-center justify-end row fill-height mb-3>
          <v-btn to="/property/propertyList" flat>Cancel</v-btn>
          <v-btn v-if="id=='property'" color="primary" @click="AddRecord">Add</v-btn>
          <v-btn v-if="id!='property'" color="primary" @click="UpdateRecord">Update</v-btn>
          <v-btn v-if="id!='property'" color="red" @click="confirmDelete=true">Delete</v-btn>
        </v-layout>
        <v-layout v-if="id!='property'">
          <v-flex d-flex xs12>
            <v-expansion-panel>
              <v-expansion-panel-content>
                <template v-slot:header>
                <div>Recent Maintenance</div>
              </template>
              <v-card>
                <v-card-text class="grey lighten-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
              </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                <div>Recent Expenses</div>
              </template>
              <v-card>
                <v-card-text class="grey lighten-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
              </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                <div>Recent Alerts</div>
              </template>
              <v-card>
                <v-card-text class="grey lighten-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
              </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="alert" persistent max-width="325">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Update Property
        </v-card-title>
        <v-card-text>
          Action was successful.<br/>Click OK to proceed.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="HandleOK">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDelete" persistent max-width="325">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Delete Property?
        </v-card-title>
        <v-card-text>
          <b>Please confirm to delete this property.</b><br/>
          This action cannot undone.<br/>All information will be lost.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="DeleteRecord">
            DELETE
          </v-btn>
          <v-btn color="primary" @click="confirmDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import db from '../../firebaseInit';

  export default {
    name: 'Property',
    data() {
      return {
        newId: '',
        isDelete: false,
        confirmDelete: false,
        alert: false,
        property: {
          nickname: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          lastUpdated: ''
        }
      }
    },
    methods: {
      GetRecord(){
        db.collection("properties").doc(this.id).get().then((doc) => {
          console.log(doc.data());
          if (doc.data())
            this.property = doc.data();
          else
            console.log("No document loaded.");
        });
      },
      AddRecord(){
        var that = this; //preserve reference before promise call
        console.log("nickname: " + this.property.nickname);

        // Add a new document with a generated id.
        db.collection("properties").add({
            userName: this.userName,
            lastUpdated: new Date(),
            nickname: this.property.nickname,
            address: this.property.address,
            city: this.property.city,
            state: this.property.state,
            zip: this.property.zip
        }).then(function(docRef) {
            console.log("Document written with ID: ", docRef.id);
            that.newId = docRef.id;
            that.alert = true;
        }).catch(function(error) {
            console.error("Error adding document: ", error);
        });
      },
      UpdateRecord(){
        var that = this; //preserve reference before promise call
        console.log("id: " + this.id);

        // Add a new document with a generated id.
        db.collection("properties").doc(this.id).set({
            userName: this.userName,
            lastUpdated: new Date(),
            nickname: this.property.nickname,
            address: this.property.address,
            city: this.property.city,
            state: this.property.state,
            zip: this.property.zip
        }).then(function() {
            console.log("Document updated with ID: ", that.id);
            that.alert = true;
        }).catch(function(error) {
            console.error("Error updating document: ", error);
        });
      },
      DeleteRecord(){
        var that = this; //preserve reference before promise call

        db.collection("properties").doc(this.id).delete().then(function() {
          console.log("Document " + that.id + " successfully deleted!");
          that.confirmDelete = false;
          that.alert = true;
          that.isDelete = true;
        }).catch(function(error) {
          console.error("Error removing document: ", error);
        });
      },
      HandleOK(){
        this.alert = false;
        if (this.newId!=''){
          this.$router.push({ name: 'property', params: { id: this.newId } });
        }
        if (this.isDelete){
          this.$router.push({ path: '/property/propertyList' });
        }
      }
    },
    computed: {
      id() {
        return this.$route.params.id;
      },
      userName() {
        return this.$store.state.user.userName;
      }
    },
    created: function() {
      this.property = {};
      this.GetRecord();
    }
  }
</script>

<style scoped>
</style>  